import { Component, OnInit } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { PopularNewsService } from './services/popular-news.service';


@Component({
  selector: 'app-popular-news',
  templateUrl: './popular-news.component.html',
  styleUrls: ['./popular-news.component.scss']
})
export class PopularNewsComponent implements OnInit {

  public slides = [
    'First slide',
    'Second slide',
    'Third slide',
    'Fourth slide',
    'Fifth slide',
    'Sixth slide'
  ];


  constructor(private publicService : PopularNewsService) { }

  ngOnInit() {
    this.publicService.getPopularNews();
  }


  public onSwiperEvent(event: string): void {
    console.log('Swiper event: ', event);
  }

  public onIndexChange(index: number): void {
    console.log('Swiper index: ', index);
  }
  



}
